/**
 * Shipping Company Bind Schema
 *
 * Zod validation schema for binding shipping companies to companies
 */

import { z } from "zod";

/**
 * Schema for binding a shipping company to a company with driver groups
 */
export const shippingCompanyBindArgsSchema = z.object({
  shippingCompany: z.object({ id: z.number() }),
  company: z.object({ id: z.number() }),
  groups: z.array(
    z.object({
      truck: z.object({
        id: z.number(),
        licensePlate: z.string(),
        renavam: z.string(),
        status: z.boolean(),
        isEnabled: z.boolean(),
        owner: z.string(),
        implementType: z.string(),
        shaftQuantity: z.number(),
        grossCapacity: z.number(),
        netCapacity: z.number(),
        color: z.string(),
        createdAt: z.string(),
        updatedAt: z.string(),
        deletedAt: z.null(),
        contact: z.array(z.unknown()),
        // Diferença: shippingCompany é um objeto completo
        shippingCompany: z
          .object({
            id: z.number(),
            isEnabled: z.boolean(),
            code: z.number(),
            name: z.string(),
            createdAt: z.string(),
            updatedAt: z.string(),
            deletedAt: z.null()
          })
          .nullable(),
        vehicleModel: z.object({
          id: z.number(),
          name: z.string(),
          truckBrand: z.object({ id: z.number(), name: z.string() })
        }),
        driver: z.object({
          id: z.number(),
          name: z.string(),
          isEnabled: z.boolean(),
          lastBlockDate: z.null(),
          deletedAt: z.null(),
          createdAt: z.string(),
          updatedAt: z.string()
        }),
        company: z.object({
          id: z.number(),
          name: z.string(),
          cnpj: z.string(),
          company: z.string(),
          uf: z.string(),
          street: z.string(),
          number: z.string(),
          complement: z.string(),
          city: z.string(),
          district: z.string(),
          zipCode: z.string(),
          status: z.boolean(),
          website: z.string(),
          logo: z.string()
        })
      }),
      driver: z.object({
        id: z.number(),
        name: z.string(),
        cpf: z.string(),
        cnh: z.string(),
        birthDate: z.string(),
        isEnabled: z.boolean(),
        company: z.object({
          id: z.number(),
          name: z.string(),
          cnpj: z.string(),
          company: z.string(),
          uf: z.string(),
          street: z.string(),
          number: z.string(),
          complement: z.string(),
          city: z.string(),
          district: z.string(),
          zipCode: z.string(),
          status: z.boolean(),
          website: z.string(),
          logo: z.string()
        }),
        // Diferença: shippingCompany é um objeto completo
        shippingCompany: z
          .object({
            id: z.number(),
            isEnabled: z.boolean(),
            code: z.number(),
            name: z.string(),
            createdAt: z.string(),
            updatedAt: z.string(),
            deletedAt: z.null()
          })
          .nullable()
      })
    })
  )
});
